<template>
  <div class="primary--text">

    <div class="d-flex flex-column justify-space-between align-center">
      <v-img aspect-ratio="1" width="100%" max-width="200px" contain src="@/assets/Mensch.svg"></v-img>
      <h1 class="display-1 font-weight-bold ma-5 white--text">Your message</h1>
    </div>

    <v-row justify="center">
      <v-col cols="12">
        <div v-if="!isMobile">
          <step-video-desktop @cancel="$emit('cancel')" @finished="$emit('finished')"/>
        </div>
        <div v-else >
          <step-video-mobile @cancel="$emit('cancel')" @finished="$emit('finished')"/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import StepVideoDesktop from "./StepVideoDesktop";
import StepVideoMobile from "./StepVideoMobile";

export default {
  name: 'StepVideo',
  components: {
    StepVideoMobile,
    StepVideoDesktop,
  },
  data: () => ({
  }),
  // ...
  computed: {
    ...mapState({
      browserVideoRecordingSupport: state => state.browserVideoRecordingSupport,
      recordedVideoFile: state => state.recordedVideo,
      question: state => state.question,
      form: state => state.form,
      isMobile: state => state.isMobile
    }),
  },
  methods: {


  }
}
</script>
